<template>
	<div id='captura'>
	<h2>AGREGAR INQUILINO</h2>
	<a @click="$router.go(-1)">regresar</a>
	<br><br>
		<form v-on:submit.prevent= 'guardarInquilino'>
		<table align="center">
			<tr>
				<td>Nombre completo </td><td><input type="text" name="nombreCompleto" required autofocus v-model="inquilinos.nombreCompleto"></td>
			</tr>
			<tr>
				<td>Email </td><td><input type="email" name="email" required v-model="inquilinos.email"></td>
			</tr>
			<tr>
				<td>Celular </td><td><input type="tel" name="celular" required v-model="inquilinos.celular"></td>
			</tr>
			<tr>
				<td>Telefono fijo </td><td><input type="tel" name="telefonoFijo" v-model="inquilinos.telefonoFijo"></td>
			</tr>
			<tr>
				<td>Whatsapp </td><td><input type="tel" name="whatsapp" required v-model="inquilinos.whatsapp"></td>
			</tr>
			<tr>
				<td>Facebook </td><td><input type="text" name="facebook" v-model="inquilinos.facebook"></td>
			</tr>
			<tr>
				<td>Calle </td><td><input type="text" name="dirCalle" required v-model="inquilinos.dirCalle"></td>
			</tr>
			<tr>
				<td>Numero </td><td><input type="text" name="dirNumero" required v-model="inquilinos.dirNumero"></td>
			</tr>
			<tr>
				<td>Interior </td><td><input type="text" name="dirInterior"  v-model="inquilinos.dirInterior"></td>
			</tr>
			<tr>
				<td>Colonia </td><td><input type="text" name="dirColonia" required v-model="inquilinos.dirColonia"></td>
			</tr>
			<tr>
				<td>Codigo </td><td><input type="number" name="dirCodigo" required minlength="5" v-model="inquilinos.dirCodigo"></td>
			</tr>
			<tr>
				<td>Ciudad </td><td><input type="text" name="dirCiudad" required v-model="inquilinos.dirCiudad"></td>
			</tr>
			<tr>
				<td>Estado </td><td><input type="text" name="dirEstado" required v-model="inquilinos.dirEstado"></td>
			</tr>
		</table>
		<br>
		<input type="submit" name="agregandoInquilino">
		</form>
	</div>
</template>

<script>
	import axios from 'axios';
	export default{
			name:'agrega-inquilino',
  			props: ['vector', 'elusuario', 'empresa'],  
			mounted(){
				this.valida();
			},
			data(){
				return {
					inquilinos:{
						nombreCompleto:'',
						email:'',
						celular:'',
						telefonoFijo:'',
						whatsapp:'',
						facebook:'',
						dirCalle:'',
						dirNumero:'',
						dirInterior:'',
						dirColonia:'',
						dirCodigo:'',
						dirCiudad:'',
						dirEstado:'',
						status:'',
						fechaModifica:'',
						quienModifico:''
					}
				};
			},
			methods:{
				valida(){
					if(!this.vector.includes('MASTERGGUV')){
						if(! this.vector.includes('Inquilinos Altas')){
							alert('Seccion no autorizada');
							document.getElementById('captura').hidden = true;
						}
					}
				},
				guardarInquilino(){
					var inquilinos1= this.inquilinos;
					var router= this.$router;
                    var statusA = 'A';

					axios.post('https://www.directodo.com/Rentus/accesosdb/agregaInquilino.php?nombreCompleto='+inquilinos1.nombreCompleto+'&email='+inquilinos1.email+'&celular='+inquilinos1.celular+'&telefonoFijo='+inquilinos1.telefonoFijo+'&whatsapp='+inquilinos1.whatsapp+'&facebook='+inquilinos1.facebook+'&dirCalle='+inquilinos1.dirCalle+'&dirNumero='+inquilinos1.dirNumero+'&dirInterior='+inquilinos1.dirInterior+'&dirColonia='+inquilinos1.dirColonia+'&dirCodigo='+inquilinos1.dirCodigo+'&dirCiudad='+inquilinos1.dirCiudad+'&dirEstado='+inquilinos1.dirEstado+'&status=' + statusA +'&fechaModifica='+this.fechaActual()+'&quienModifico='+ this.elusuario)
		  		          .then((respue) => {
		  		          		if (respue.statusText == 'OK'){
                                    alert("Inquilino dado de alta satisfactoriamente");
		  		          			router.push('/inq')
		  		          		}
		  			 	  })
		  		          .catch((error) =>{
		  		          		console.log(error);
		  		          });
				},

				fechaActual(){
				    var currentDate = new Date() //hoy
				    var day = currentDate.getDate();
				    var month = currentDate.getMonth() + 1;
				    var year = currentDate.getFullYear();
				    var my_date = year+"-"+month+"-"+day;
				    return my_date;    
				}

			}
	}
</script>


// WEBPACK FOOTER //
// src/Inquilino-agregar.vue